import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private readonly http: HttpClient) { }

  get<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.get<T>(endpoint, { params, headers });
  }

  getWithHeaders<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.get<T>(endpoint, { params, headers, observe: 'response' as 'body' });
  }

  postWithHeaders<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.post<T>(endpoint, params, {headers: headers, observe: "response" as "body"});
  }

  post<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.post<T>(endpoint, params, {headers: headers});
  }

  put<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.put<T>(endpoint, params, {headers});
  }

  delete<T>(endpoint: string, params = {}, customHeaders = {}): Observable<T> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.delete<T>(endpoint, { params, headers });
  }

  deleteBody<T>(endpoint: string, params = {}): Observable<T> {
    return this.http.request<T>('delete', endpoint, { body: params });
  }

  downloadFile(endpoint: string, params = {}, customHeaders = {}): Observable<string> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.get(endpoint, { params, headers, responseType: 'text' });
  }

  downloadFileCSVPOST(endpoint: string, data: any): Observable<string> {
    return this.http.post(endpoint, data, { responseType: 'text' });
  }

  downloadFileCSVGET(endpoint: string): Observable<string> {
    return this.http.get(endpoint, { responseType: 'text' });
  }

  downloadFileXlsxPOST(endpoint: string, data: any): Observable<Blob> {
    return this.http.post(endpoint, data, { responseType: 'blob' });
  }

  downloadFilePdfGET(endpoint: string): Observable<Blob> {
    return this.http.get(endpoint, { responseType: 'blob' });
  }

  postImg(endpoint: string, params = {}, customHeaders = {}): Observable<Blob> {
    const headers = new HttpHeaders(customHeaders);
    return this.http.post(endpoint, params, {headers, responseType: 'blob'});
  }

}
